import './Footer.css'

const Footer = () => {
    return(
      
      <div className='footer'>
        <div className='container'>
            <h5>법무법인 법과사람들</h5>
            <p>주소 : 인천 미추홀구 소성로 159, 201호(학익동, 현준솔로몬시티)</p>
            <p>사업자번호 : 178-88-01412</p>
            <p>대표 변호사 : 우희창 | 관리자 : 전재원 팀장 </p>
            <p>연락처 : 032-873-2211 | Fax : 032-873-5211</p>
            <p>이메일 : lawnpeople1@naver.com</p>
            <p>© 2023 Law & People. All Rights Reserved.</p>
        </div>
      </div>
    )
}

export default Footer;